import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { CrmNotice } from './models';

@Injectable({ providedIn: 'root' })
export class NoticeBoard {
  private readonly http = inject(HttpClient);
  readonly items = signal<CrmNotice[]>([]);
  readonly unread = computed(() => this.items().filter((item) => !item.read).length);

  refresh(): void {
    this.http.get<CrmNotice[]>('/api/crm/notices').subscribe({
      next: (rows) => this.items.set(rows),
    });
  }

  acknowledge(item: CrmNotice, then: (saved: CrmNotice) => void): void {
    this.http.post<CrmNotice>(`/api/crm/notices/${item.id}/read`, {}).subscribe({
      next: (saved) => {
        this.items.update((rows) => rows.map((row) => (row.id === saved.id ? saved : row)));
        then(saved);
      },
    });
  }
}
